import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { redirects } from '@lib/redirects';
import { Route } from '@packages/router';
import React from 'react';

export const routes$ = {
    WalletList: AsyncPageRender(() => pageModule(import('./Views/Main'))),
    WalletAdd: AsyncPageRender(() => pageModule(import('./Views/AddCredit'))),
    WalletSuccess: AsyncPageRender(() => pageModule(import('./Views/Success'))),
};

function Router() {
    return (
        <>
            {redirects({
                '/wallet': '/wallet/list',
            })}
            <Route name={'Wallet.List'} exact path={'/wallet/list'} component={ProtectedRoute(routes$.WalletList)} />
            <Route
                name={'Wallet.Add'}
                exact
                path={'/wallet/:id/add-credit'}
                component={ProtectedRoute(routes$.WalletAdd)}
            />
            <Route
                name={'Wallet.Success'}
                exact
                path={'/wallet/:customerId/wallet-success/:walletId'}
                component={ProtectedRoute(routes$.WalletSuccess)}
            />
        </>
    );
}

export default Router;
